import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import * as Yup from "yup";
import DateTimeInputFormik from "../../../../components/UI/DateTimeInput/DateTimeInputFormik";
import HtmlEditor from "../../../../components/UI/HtmlEditorInput/HtmlEditor";
import TextInputFormik from "../../../../components/UI/TextInput/TextInputFormik";
import TextInputNumberFormik from "../../../../components/UI/TextInput/TextInputNumberFormik";

const validationSchema = Yup.object().shape({
  sqAcaoFiscal: Yup.string().default(""),
  sqItemOcorrencia: Yup.string().default(""),
  sqItem: Yup.string().default(""),
  txReferencia: Yup.string().default(""),
  dtVencimento: Yup.string().default(""),
  vlDeclarado: Yup.string().default(""),
  vlApurado: Yup.string().default(""),
  vlIcms: Yup.string().default(""),
  vlIcmsRecolhido: Yup.string().default(""),
  dsItem: Yup.string().default(""),
  vlMultaOcorrenciaAtual: Yup.string().default(""),
  vlTotalNota: Yup.string().default(""),
  vlProduto: Yup.string().default(""),
});

const initialValues = {};
validationSchema._nodes.forEach((key) => {
  initialValues[key] = "";
});

const DemonstrativoE = ({ formik }) => (
  <>
    <Row>
      <Form.Group className="mb-3" as={Col} sm={12} md={12}>
        <span>Descrição:</span>
        <HtmlEditor formik={formik} field="dsItem" />
      </Form.Group>
      <Form.Group className="mb-3" as={Col} sm={12} md={4}>
        <Form.Label>Data de Vencimento:</Form.Label>

        <DateTimeInputFormik formik={formik} field="dtVencimento" />
      </Form.Group>
      <Form.Group className="mb-3" as={Col} sm={12} md={4}>
        <Form.Label>Equipamento:</Form.Label>
        <TextInputFormik formik={formik} field="equipamento" type="text" />
      </Form.Group>
    </Row>
    <Row>
      <Form.Group className="mb-3" as={Col} sm={12} md={4}>
        <Form.Label>N° de Série Equipamento:</Form.Label>
        <TextInputFormik formik={formik} field="numeroSerie" type="text" />
      </Form.Group>
      <Form.Group className="mb-3" as={Col} sm={12} md={4}>
        <Form.Label>Marca:</Form.Label>
        <TextInputFormik formik={formik} field="marca" type="text" />
      </Form.Group>
    </Row>
    <Row>
      <Form.Group className="mb-3" as={Col} sm={12} md={4}>
        <Form.Label>Modelo:</Form.Label>
        <TextInputFormik formik={formik} field="modelo" type="text" />
      </Form.Group>
      <Form.Group className="mb-3" as={Col} sm={12} md={4}>
        <Form.Label>Versão:</Form.Label>
        <TextInputNumberFormik formik={formik} field="versao" type="number" />
      </Form.Group>
    </Row>
  </>
);

export default DemonstrativoE;
